import { useSyncExternalStore } from "react";

// Nothing to subscribe to: the value flips exactly once, when React swaps the
// server snapshot for the client one at the end of hydration.
const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` while server-rendering and during the hydration render, `true` once
 * the client has taken over.
 *
 * Lets a component server-render placeholder markup and mount browser-only UI
 * afterwards — `useSyncExternalStore` keeps the hydration render matching the
 * server HTML, so this costs no hydration mismatch.
 */
export const useIsClient = (): boolean =>
  useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
